export const PREBUILT_DASHBOARDS_COLUMN_VISIBILITY = {
  // Show only these specific columns
  name: true,
  run_count: true,
  total_cost: true,
  last_run_start_time: true,

  // Hide all other columns
  start_time: false,
  end_time: false,
  total_tokens: false,
  feedback_count: false,
  feedback_stats: false,
  description: false,
  id: false,
  metadata: false,
  tags: false,
  actions: false,
  prompt_tokens: false,
  completion_tokens: false,
  error_rate: false,
  streaming_rate: false,
  latency_p50: false,
  latency_p99: false,
};

export const PREBUILT_DASHBOARDS_SORTABLE_COLUMNS = [
  'name',
  'total_tokens',
  'total_cost',
  'last_run_start_time',
];

export const PREBUILT_DASHBOARDS_FILTER = {
  reference_free: true,
  offset: 0,
  limit: 10,
  sort_by: 'last_run_start_time',
  sort_by_desc: true,
  filter: "and(neq(name, 'evaluators'), neq(name, 'playground'))",
};
